import React from 'react';
import TemplateModern from './TemplateModern';
import TemplateElegant from './TemplateElegant';
import TemplateTrust from './TemplateTrust';
import { NICHES_CONFIG, DB_NICHE_TO_KEY } from './niches';

const TEMPLATES = {
  modern: TemplateModern,
  elegant: TemplateElegant,
  trust: TemplateTrust,
  default: TemplateModern // Fallback por si acaso
};

const TemplateRenderer = ({ workshopData }) => {
  // Convertimos el valor de BD al key de NICHES_CONFIG, con fallback a 'otros'
  const nicheKey = DB_NICHE_TO_KEY[workshopData?.niche] || workshopData?.niche || 'otros';
  const nicheConfig = NICHES_CONFIG[nicheKey] || NICHES_CONFIG['otros'];
  
  // Obtenemos la clave del template o usamos un fallback
  const templateKey = nicheConfig?.template || 'default';
  const TemplateComponent = TEMPLATES[templateKey] || TEMPLATES.default;

  // Renderizamos el template inyectando los datos del taller y la config del nicho
  return <TemplateComponent data={workshopData} config={nicheConfig} />;
};

export default TemplateRenderer;